import {
    FieldValues,
    FormProvider,
    useForm,
    useFormContext,
    UseFormMethods,
} from "react-hook-form";
import SelectComBusca from "../CardsPages/Forms/SelectComBusca";
import FormInput from "./FormInput";
import FormLazySelect from "./FormLazySelect";
import FormSearchSelect from "./FormSearchSelect";
import FormSelect from "./FormSelect";
import FormSelectCategoriaAtendimento from "./FormSelectCategoriaAtendimento";
import { FormSubmitButton } from "./FormSubmitButton";
import FormSwitch from "./FormSwitch";
import FormTextarea from "./FormTextarea";
import FormInputButton from "./FormInputButton";

export interface IFormProps<T = any>
    extends React.DetailedHTMLProps<
        React.FormHTMLAttributes<HTMLFormElement>,
        HTMLFormElement
    > {
    usingContext?: boolean;
    handleSubmit: (formData: T) => void;
    children:
        | React.ReactNode
        | ((formMethods: UseFormMethods<T>) => React.ReactNode);
}

type TFormExport = React.FC<IFormProps> & {
    Input: typeof FormInput;
    InputButton: typeof FormInputButton;
    Select: typeof FormSelect;
    Textarea: typeof FormTextarea;
    LazySelect: typeof FormLazySelect;
    SearchSelect: typeof FormSearchSelect;
    SelectCategoriaAtendimento: typeof FormSelectCategoriaAtendimento;
    SubmitButton: typeof FormSubmitButton;
    Switch: typeof FormSwitch;
    SelectComBusca: typeof SelectComBusca;
};

/**
 * @param usingContext se true as funções de  formulário
 * serão resgatadas por contexto ( NECESSÁRIO colocar um
 * FormProvider em volta ), se false não é necessário
 * uso de provider. default: false
 */
const UnForm: TFormExport = (<T extends FieldValues = any>(
    props: IFormProps
) => {
    const { usingContext, handleSubmit, ...formProps } = props;

    const formHook = useForm<T>();

    if (usingContext) {
        return <FormWithReadyContext {...props} />;
    } else {
        const children: React.ReactNode =
            typeof props.children === "function"
                ? props.children(formHook)
                : props.children;

        return (
            <FormProvider {...formHook}>
                <form
                    {...formProps}
                    onSubmit={formHook.handleSubmit(handleSubmit)}
                    children={children}
                />
            </FormProvider>
        );
    }
}) as TFormExport;

function FormWithReadyContext(props: IFormProps) {
    const { usingContext, handleSubmit, ...formProps } = props;
    const formHook = useFormContext();
    const { handleSubmit: formHandleSubmit } = formHook;

    const children: React.ReactNode =
        typeof props.children === "function"
            ? props.children(formHook)
            : props.children;

    return (
        <form
            onSubmit={formHandleSubmit(handleSubmit)}
            {...formProps}
            children={children}
        />
    );
}

UnForm.Input = FormInput;
UnForm.InputButton = FormInputButton;
UnForm.Select = FormSelect;
UnForm.Textarea = FormTextarea;
UnForm.LazySelect = FormLazySelect;
UnForm.SearchSelect = FormSearchSelect;
UnForm.SelectCategoriaAtendimento = FormSelectCategoriaAtendimento;
UnForm.Switch = FormSwitch;
UnForm.SubmitButton = FormSubmitButton;
UnForm.SelectComBusca = SelectComBusca;

export default UnForm;
